import axios from 'axios'
import api from '@/api/api'
import state from '@/store/module_principal/state'

export default {
  testetelegram (codigoTelegram) {
    let PALERTABOT_TOKEN = '5087298799:AAHkiWdw2ym5KJkvrolPNY0nMa9iaHqQIRM'
    let msg = 'Teste enviado do pesquisa.'
    return axios.get('https://api.telegram.org/bot' + PALERTABOT_TOKEN + '/sendMessage?chat_id=' + codigoTelegram + '&parse_mode=HTML&text=' + msg).then(result => result.data)
  },
  buscatelegram (codigoUsuario, cidade) {
    var info = { 
      codigoUsuario: codigoUsuario,
      cidade:cidade
    }
    var token = { token: api.aesEncrypt(JSON.stringify(info)) }
    return axios.post(state.ip.protocolo + "://" + state.ip.backendIp + state.ip.backendPort + '/retornaTelegram', token, {
        headers: {
            "content-type": "application/x-www-form-urlencoded"
        }
    }).then(result => result.data)
  },
  gravatelegram (codigoUsuario, codigoTelegram, cidade) {
    var info = { 
      codigoUsuario: codigoUsuario,
      codigoTelegram: codigoTelegram,
      cidade: cidade
    }
    var token = { token: api.aesEncrypt(JSON.stringify(info)) }
    return axios.post(state.ip.protocolo + "://" + state.ip.backendIp + state.ip.backendPort + '/gravaTelegram', token, {
        headers: {
            "content-type": "application/x-www-form-urlencoded"
        }
    }).then(result => result.data)
  },
}